import { styled } from "@mui/material";
import { default as MuiBox } from "@mui/material/Box";

/**
 * Custom `Box` element.
 */
export const Box = styled(MuiBox)(({ maxWidth }) => ({
  maxWidth: typeof maxWidth === "number" ? maxWidth : "100%",
}));
